module.exports = __webpack_public_path__ + "static/media/row-level-security-icon.d8a3dc53.svg";